import { connect } from "react-redux";
import { RootState } from "state/rootReducer";
import { TAG_COLORS, UNKNOWN_TAG_COLOR } from "shared/tagColors";

interface OwnProps {
  onSelect: (tag: Tag) => void;
  onDeselect: (tag: Tag) => void;
  enabledTags: Tag[];
  squareSize?: number | string;
  squareSpacing?: number | string;
}

interface StateProps {
  possibleTags: Tag[];
}

export type TagArrayProps = OwnProps & StateProps;

export function TagArray(props: TagArrayProps): JSX.Element {
  const size = props.squareSize || "1.25rem";

  return (
    <div className="flex flex-row items-center gap-x-1.5">
      {props.possibleTags.map((tag) => {
        const enabled = props.enabledTags.includes(tag);
        const color = TAG_COLORS[tag] ?? UNKNOWN_TAG_COLOR;

        return (
          <button
            key={`${tag}-tag-toggle`}
            type="button"
            aria-pressed={enabled}
            aria-label={`${tag} tag`}
            title={`${tag} tag`}
            onClick={() =>
              enabled ? props.onDeselect(tag) : props.onSelect(tag)
            }
            className="rounded-full transition-transform hover:scale-110 cursor-pointer"
            style={{
              width: size,
              height: size,
              // Filled when on, a ring when off — so state reads at a glance
              // without needing a second colour.
              backgroundColor: enabled ? color.swatch : "transparent",
              border: `2px solid ${enabled ? color.swatch : color.ring}`,
            }}
          ></button>
        );
      })}
    </div>
  );
}

function mapState(state: RootState, _ownProps: OwnProps): StateProps {
  return {
    possibleTags: state.user.possibleTags || [],
  };
}

export default connect(mapState)(TagArray);
